export default "__VITE_ASSET__BqZ9qh5b__";